import 'Styles/sidebar.scss';

import 'isomorphic-fetch';

import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { push, goBack } from 'react-router-redux';

import isEqual from 'lodash/isEqual';

import { exitTopify } from 'Actions/GlobalMetaActions';
import { doLogout } from 'Actions/authenticateActions';

import { sidebarOff, showLoginModal, showConfirmModal, displayNotification } from 'Actions/UiActions';
import { refreshPage } from 'Actions/GlobalMetaActions';
import { trackGAEvent } from 'Actions/adsActions';
import { currentUser } from 'Actions/ContextInfoActions';
import * as Nav from 'Utils/nav/NavHelpers';

import sidebarSelector from 'Selectors/sidebarSelector';

import UserIcon from 'Components/common/UserIconComponent';
import SvgIcon from 'Components/svg/SvgIcon';

import decode from 'Utils/entities';

class SidebarComponent extends React.Component {
	constructor(props) {
		super(props);

		this.currentUser = null;
	}

	shouldComponentUpdate( nextProps ) {
		return (
			this.props.ustate.id !== nextProps.ustate.id ||
			this.props.ustate.notifications !== nextProps.ustate.notifications||
			this.props.isOpen !== nextProps.isOpen ||
			!isEqual( this.props.custom_links, nextProps.custom_links )
		);
	}

	componentDidUpdate( prevProps ) {
		// Let's check if we have new notifications
		if( this.props.ustate.notifications && this.props.ustate.notifications.pms) {
			if(
				( !prevProps.ustate.notifications && this.props.ustate.notifications.pms > 0 ) ||
				prevProps.ustate.notifications.pms < this.props.ustate.notifications.pms
			) {
				let message = 'You have ' + this.props.ustate.notifications.pms + ' new ';
				message += parseInt( this.props.ustate.notifications.pms ) === 1 ? 'message' : 'messages';
				displayNotification( 'info', message, { timeout: 2000 } );
			}
		}

		if( this.props.isOpen && prevProps.isOpen === false ) {
			// using pushState to avoid popstate to be triggered
			history.pushState( { topifyExtra: true, type: 'sidebar' }, '', window.location );
		}
	}

	toggleSidebar = () => {
		if( this.props.isOpen ) {
			this.props.dispatch( goBack() );
			this.props.dispatch( sidebarOff() );
		}
		return true;
	};

	goToSection( newPath ) {
		let currentPath = Nav.parsePath( this.props.routing.locationBeforeTransitions.pathname );
		if( newPath === currentPath[0] ) {
			this.props.dispatch( refreshPage() );
		} else {
			this.props.dispatch( push( newPath ) );
		}
	}

	gotoRoot = () => {
		this.goToSection( Nav.pathToRoot() );
		this.props.dispatch( trackGAEvent(false, 'goToRoot', 'uiAction', 'sideMenu') );
	};

	gotoForumsIndex = () => {
		this.goToSection( Nav.pathToForumsIndex() );
		this.props.dispatch( trackGAEvent(false, 'goToForumsIndex', 'uiAction', 'sideMenu') );
	};

	gotoActiveTopics = () => {
		this.goToSection( Nav.pathToActiveTopics() );
		this.props.dispatch( trackGAEvent(false, 'goToActive', 'uiAction', 'sideMenu') );
	};

	gotoSubscribed = () => {
		this.goToSection( Nav.pathToSubscribed() );

		this.props.dispatch( trackGAEvent(false, 'goToSubscribed', 'uiAction', 'sideMenu') );
	};

	gotoParticipated = () => {
		this.goToSection( Nav.pathToParticipated() );

		this.props.dispatch( trackGAEvent(false, 'goToParticipated', 'uiAction', 'sideMenu') );
	};

	gotoNewPosts = () => {
		this.goToSection( Nav.pathToNewPosts() );

		this.props.dispatch( trackGAEvent(false, 'goToNewPosts', 'uiAction', 'sideMenu') );
	};

	gotoLink( link ) {
		this.toggleSidebar();
		window.open( link.url );

		// Record the Google Analytics event.
		this.props.dispatch( trackGAEvent( false, 'followedExternalLink', 'userAction', 'consumption') );
		this.props.dispatch( trackGAEvent( false, 'followedExternalLink', 'uiAction', 'sideMenu') );
	}

	goToMessages = () => {
		if( this.props.ustate.id ) {
			this.goToSection( Nav.pathToMessages() );

			// Record the Google Analytics event.
			this.props.dispatch( trackGAEvent( false, 'messageNotificationIcon', 'uiAction', 'sideMenu' ) );
		} else {
			// for guests show the login modal
			this.props.dispatch( showLoginModal() );
			// Record the Google Analytics event.
			this.props.dispatch( trackGAEvent( false, 'sideMenuMessageNotificationIcon', 'userAction', 'loginPrompt' ) );
		}
	};

	gotoOnline = () => {
		this.goToSection( Nav.pathToOnline() );

		this.props.dispatch( trackGAEvent(false, 'goToOnline', 'uiAction', 'sideMenu') );
	};

	gotoReleaseNotes = () => {
		this.goToSection( Nav.pathToReleaseNotes() );

		this.props.dispatch( trackGAEvent(false, 'gotoReleaseNotes', 'uiAction', 'sideMenu'));
	};

	_showLoginModal = () => {
		this.props.dispatch( showLoginModal() );

		this.props.dispatch( trackGAEvent( false, 'login', 'uiAction', 'sideMenu') );
	};

	_showLogoutModal = () => {
		this.props.dispatch( sidebarOff() );
		this.props.dispatch( showConfirmModal( 'Sign Out', 'Are you sure you want to sign out of the current forum?', doLogout.bind( this ) ) );
		this.props.dispatch( trackGAEvent(false, 'logout', 'uiAction', 'sideMenu') );
	};

	_showExitModal = () => {
		this.props.dispatch( sidebarOff() );
		this.props.dispatch( showConfirmModal( 'Exit Mobile View', 'Are you sure you want exit to the desktop version?', exitTopify.bind( this ) ) );
		//Tracks exit analytics event in exitTopify function since program does not return
		this.props.dispatch( trackGAEvent(false, 'exitTopify', 'uiAction', 'sideMenu') );
	};

	gotoRegister = ( e ) => {
		this.props.dispatch( sidebarOff() );

		let thisLocation = this.props.routing.locationBeforeTransitions,
			redirectUrl = this.props.ustate.registerUrl,
			mobileurl = thisLocation.pathname ? thisLocation.pathname.replace( /^\//, '' ) + thisLocation.search : '';

		switch( e.currentTarget.dataset.type ) {
			case 'register':
				redirectUrl = this.props.ustate.registerUrl;
				break;

			case 'storefront':
				redirectUrl = this.props.ustate.storeFrontUrl;
				break;
		}

		document.location.replace( `${ redirectUrl }${ /\?/i.test( redirectUrl ) ? '&' : '?' }mobileurl=${ mobileurl ? encodeURIComponent( mobileurl ) : '/' }` );
	};

	getMessagesNotifications() {
		let className = '',
			counter = '';
		if( this.props.ustate.notifications && this.props.ustate.notifications.pms ) {
			className = ' notification_on';
			counter = <span className="sideMenuCounter">{ this.props.ustate.notifications.pms }</span>;
		}

		return <li className={ `messages-icon${ className }` } onClick={ this.goToMessages } >
			{ counter }
			<SvgIcon size="32px" icon="message" />
		</li>
	}

	getUserLink() {
		if( this.props.ustate.id ) {
			if( !this.currentUser || this.currentUser.id !== this.props.ustate.id || this.props.isOpen ) {
				this.currentUser = this.props.dispatch( currentUser() );
			}
			return <UserIcon user={ this.currentUser } layout="sidemenu"/>;
		}
		return null;
	}

	render() {
		let opened = this.props.isOpen ? 'opened' : '';

		let userLoggedIn = this.props.ustate.id;
		const customLinks_items = this.props.custom_links.map(
			(p, i) => <li key={ i } className="item" onClick={ () => this.gotoLink( p ) }><span>{ decode(p.text) }</span></li>
		);
		let customLinks = this.props.custom_links.length > 0 ? <ul className="links custom-links">{customLinks_items}</ul> : <span />;

		let perms = {
			subscribed: this.props.ustate.perms && this.props.ustate.perms.search && userLoggedIn,
			participated: this.props.ustate.perms && this.props.ustate.perms.participated && userLoggedIn,
			latest: this.props.ustate.perms && this.props.ustate.perms.latest,
			updated: this.props.ustate.perms && this.props.ustate.perms.updated && userLoggedIn,
			whosonline: this.props.ustate.perms && this.props.ustate.perms.whosonline
		};

		const home = process.env.config.section.home === true ? <li onClick={ this.gotoRoot }>Home</li> : null,
			messagesNotifications = this.getMessagesNotifications(),
			userLink = this.getUserLink(),
			messages = userLoggedIn ? <li onClick={ this.goToMessages }>Private Messages</li> : null,
			signInOut = userLoggedIn ? <li onClick={ this._showLogoutModal }>Sign Out</li> : <li onClick={ this._showLoginModal }>Sign In for More</li>,
			subscribed = perms.subscribed ? <li onClick={ this.gotoSubscribed }>Subscribed</li> : null,
			participated = perms.participated ? <li onClick={ this.gotoParticipated }>Participated</li> : null,
			latest = perms.latest ? <li onClick={ this.gotoActiveTopics }>Active Topics</li> : null,
			newPosts = perms.updated ? <li onClick={ this.gotoNewPosts }>New Posts</li> : null,
			whosonline = perms.whosonline ? <li onClick={ this.gotoOnline }>Who&#39;s Online</li> : null,
			register = !userLoggedIn && this.props.ustate.registerUrl && this.props.isVS ? <li data-type="register" onClick={ this.gotoRegister }>Register</li> : null,
			storeFront = !userLoggedIn && this.props.ustate.storeFrontUrl && this.props.isVS ? <li data-type="storefront" onClick={ this.gotoRegister }>Advertise with Us</li> : null;

		return (
			<section id="sideMenu" className={ 'nolinks sidebar ' + opened }>
				<ul className="notifications">
					{ messagesNotifications }
					<li className="notifications-icon">
						<SvgIcon size="32px" icon="notification" />
					</li>
					<li className="releases-icon" onClick={ this.gotoReleaseNotes }>
						<SvgIcon size="32px" icon="info_outline" />
					</li>
				</ul>
				<nav className="links">
					{ userLink }
					{ home }
					<li onClick={ this.gotoForumsIndex }>Forums Index</li>
					{ subscribed }
					{ participated }
					{ latest }
					{ newPosts }
					{ messages }
					{ whosonline }
					{ signInOut }
					{ register }
					{ storeFront }
					<li onClick={ this._showExitModal }>
						Exit Enhanced Mobile View
					</li>
				</nav>
				{ customLinks }
			</section>
		)
	}
}

SidebarComponent.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	dispatch: PropTypes.func.isRequired,
	custom_links: PropTypes.array.isRequired
};

export default connect( sidebarSelector )( SidebarComponent );



// WEBPACK FOOTER //
// ./src/components/common/SidebarComponent.js